export default "__VITE_ASSET__lJjRct48__"